import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import { ExportState } from "./types";
import { ExportFilters } from "@/models/export/filters";

const state: ExportState = {
  exportFilters: {} as ExportFilters
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
